var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentExtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#1356DA;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43,12.3h13.9c2.1,0,3.8,1.7,3.8,3.8v31.5c0,2.1-1.7,3.8-3.8,3.8H7.1c-2.1,0-3.8-1.7-3.8-3.8V16.1 c0-2.1,1.7-3.8,3.8-3.8H21"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.9,
    y: 51.4,
    className: "st0",
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 19,
    y1: 61.7,
    x2: 45,
    y2: 61.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "27.9,2.3 43,2.3 43,26.3 21,26.3 21,9.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "28,2.3 28,9.3 21,9.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 26.9,
    y1: 31.8,
    x2: 26.9,
    y2: 46.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "31,42.3 26.9,46.4 22.8,42.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 37.1,
    y1: 46.4,
    x2: 37.1,
    y2: 31.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "33,35.9 37.1,31.8 41.2,35.9  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentExtract);
export default __webpack_public_path__ + "static/media/document-extract.b22dcd751a47effcaf684ba276f0d016.svg";
export { ForwardRef as ReactComponent };